export const BOTS_SYSTEM = 'http://polarissleep.com/bots';

/** Identifies a Bot by its base name, which is the same in every environment. Role access policies use it. */
export const BOT_NAME_SYSTEM = 'https://polarissleep.com/bot-name';
